var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 97,
    viewBox: "0 0 128 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7421 68H11.8313V29.797L0 33.4664V25.4074L20.679 18H21.7421V68Z",
    fill: "url(#paint0_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 50,
    r: 45,
    fill: "#FEF6F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.203 81.3378L73.1405 69.6715L72.4805 68.4846L89.7305 15.2786L127.135 25.758L127.794 26.9449L111.203 81.3378Z",
    fill: "#253E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.545 80.1503L72.4824 68.484L89.0724 14.0911L127.136 25.7574L110.545 80.1503Z",
    fill: "#355468"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0715 14.0906L94.1863 15.6558L101.082 78.1928L73.1395 69.6714L72.4805 68.4845L89.0715 14.0906Z",
    fill: "#B5ABA0",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5816 73.4415L45.0706 77.9043L43.7746 76.8658L38.7246 8.58316L85.9386 3.08081L87.2346 4.12033L93.5816 73.4415Z",
    fill: "#EE2C4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2867 72.403L43.7757 76.8658L37.4297 7.54364L85.9397 3.08081L92.2867 72.403Z",
    fill: "#EE4D2D"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0254 21.9309L52.3438 77.1888L87.5176 74.192L105.039 79.4003L103.202 21.3354L54.0254 21.9309Z",
    fill: "#B5ABA0",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3359 86.6172H100.956V19.2117H56.3359V86.6172Z",
    fill: "#9B8366"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3359 85.9026H100.956V18.4971H56.3359V85.9026Z",
    fill: "#F7DC57"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.292946
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6906 82.8277H58.5996L59.1076 58.9828L59.5996 22.6958H97.6906V58.5788L98.6906 82.8277Z",
    fill: "#B5ABA0",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5996 82.0933H97.6906V21.9614H59.5996V82.0933Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.299293
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3555 18.4282C90.8025 18.4282 90.3555 18.8763 90.3555 19.4307V23.4223C90.3555 24.106 89.8005 24.6623 89.1185 24.6623H88.7635C88.5425 24.4879 88.2775 24.3676 87.9746 24.3676H69.3155C69.0125 24.3676 68.7475 24.4879 68.5265 24.6623H68.1715C67.4905 24.6623 66.9355 24.106 66.9355 23.4223V19.4307C66.9355 18.8763 66.4885 18.4282 65.9355 18.4282C65.3825 18.4282 64.9355 18.8763 64.9355 19.4307V23.4223C64.9355 25.2117 66.3875 26.6672 68.1715 26.6672H68.5255C68.7465 26.8426 69.0125 26.9629 69.3155 26.9629H87.9746C88.2775 26.9629 88.5436 26.8426 88.7645 26.6672H89.1185C90.9035 26.6672 92.3555 25.2117 92.3555 23.4223V19.4307C92.3555 18.8763 91.9085 18.4282 91.3555 18.4282Z",
    fill: "#B5ABA0",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1205 26.0581H68.1745C66.3905 26.0581 64.9375 24.6025 64.9375 22.8142V18.8215C64.9375 18.2682 65.3855 17.8191 65.9375 17.8191C66.4905 17.8191 66.9375 18.2682 66.9375 18.8215V22.8142C66.9375 23.4969 67.4925 24.0532 68.1745 24.0532H89.1205C89.8035 24.0532 90.3575 23.4969 90.3575 22.8142V18.8215C90.3575 18.2682 90.8055 17.8191 91.3575 17.8191C91.9105 17.8191 92.3575 18.2682 92.3575 18.8215V22.8142C92.3575 24.6025 90.9055 26.0581 89.1205 26.0581Z",
    fill: "#A5A4A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9745 26.3538H69.3155C68.6005 26.3538 68.0215 25.7724 68.0215 25.0557C68.0215 24.339 68.6005 23.7585 69.3155 23.7585H87.9745C88.6895 23.7585 89.2695 24.339 89.2695 25.0557C89.2695 25.7724 88.6895 26.3538 87.9745 26.3538Z",
    fill: "#355468"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4136 32.4936L98.4626 32.4755L97.8356 30.5288L97.3516 32.5096L97.4006 32.5226C97.7336 32.6159 98.0866 32.6048 98.4136 32.4936Z",
    fill: "#3D3D3D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0017 34.0893H63.5566C63.2796 34.0893 63.0566 33.8648 63.0566 33.5881C63.0566 33.3115 63.2796 33.0869 63.5566 33.0869H93.0017C93.2777 33.0869 93.5017 33.3115 93.5017 33.5881C93.5017 33.8648 93.2777 34.0893 93.0017 34.0893Z",
    fill: "#EE4D2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3146 41.1123H63.5566C63.2806 41.1123 63.0566 40.8877 63.0566 40.6111C63.0566 40.3344 63.2806 40.1099 63.5566 40.1099H85.3146C85.5906 40.1099 85.8146 40.3344 85.8146 40.6111C85.8146 40.8877 85.5906 41.1123 85.3146 41.1123Z",
    fill: "#EE4D2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0176 48.135H63.5566C63.2806 48.135 63.0566 47.9105 63.0566 47.6338C63.0566 47.3571 63.2806 47.1326 63.5566 47.1326H87.0176C87.2936 47.1326 87.5176 47.3571 87.5176 47.6338C87.5176 47.9105 87.2936 48.135 87.0176 48.135Z",
    fill: "#EE4D2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4236 55.158H63.5566C63.2796 55.158 63.0566 54.9334 63.0566 54.6567C63.0566 54.3801 63.2796 54.1555 63.5566 54.1555H90.4236C90.6996 54.1555 90.9236 54.3801 90.9236 54.6567C90.9236 54.9334 90.6996 55.158 90.4236 55.158Z",
    fill: "#EE4D2D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3456 62.1809H63.5566C63.2806 62.1809 63.0566 61.9563 63.0566 61.6797C63.0566 61.403 63.2806 61.1785 63.5566 61.1785H82.3456C82.6216 61.1785 82.8456 61.403 82.8456 61.6797C82.8456 61.9563 82.6216 62.1809 82.3456 62.1809Z",
    fill: "#EE4D2D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7407 72.7544H63.5566C63.2806 72.7544 63.0566 72.5298 63.0566 72.2532C63.0566 71.9765 63.2806 71.752 63.5566 71.752H76.7407C77.0167 71.752 77.2407 71.9765 77.2407 72.2532C77.2407 72.5298 77.0167 72.7544 76.7407 72.7544Z",
    fill: "#EE4D2D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.717 77.4102H82.71C80.595 77.4022 79.898 72.5164 79.779 71.538C79.746 71.2623 79.942 71.0127 80.215 70.9796C80.478 70.9365 80.738 71.141 80.772 71.4167C81.026 73.5068 81.841 76.4048 82.714 76.4078H82.715C83.203 76.4078 83.485 75.4585 83.756 74.5403C84.142 73.2371 84.618 71.6041 86.152 71.7535C87.246 71.8527 87.762 72.9374 88.216 73.8947C88.486 74.4641 88.821 75.1718 89.126 75.1728H89.127C89.565 75.1728 89.976 74.5363 90.306 74.024C90.672 73.4566 91.01 72.9073 91.584 72.9715C92.099 73.0186 92.38 73.5438 92.568 73.9959C92.717 74.3558 92.878 74.5844 93.021 74.6355C93.227 74.7187 93.668 74.4922 94.129 74.2566C94.69 73.9689 95.388 73.612 96.237 73.4807C96.507 73.4406 96.765 73.6271 96.807 73.8997C96.849 74.1734 96.662 74.429 96.389 74.4711C95.699 74.5784 95.107 74.8821 94.583 75.1487C93.922 75.4876 93.297 75.8073 92.675 75.5768C92.244 75.4184 91.916 75.0375 91.644 74.3799C91.583 74.2325 91.531 74.1313 91.491 74.0651C91.385 74.1984 91.246 74.412 91.146 74.5683C90.707 75.247 90.109 76.1752 89.128 76.1752H89.122C88.19 76.1722 87.743 75.2329 87.313 74.3257C86.957 73.5759 86.589 72.799 86.062 72.7529C85.403 72.6988 85.097 73.5348 84.715 74.825C84.356 76.0369 83.949 77.4102 82.717 77.4102Z",
    fill: "#EE4D2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 18,
    x2: 0,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.0fa68a08e690a8683d587be43b2897b6.svg";
export { ForwardRef as ReactComponent };